export default __webpack_public_path__ + "static/media/edit-small.ce02e309.svg";